<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapname2">Contents</h1>
<h2 class="toc-chap"><a href="#/xhtml/teil1">An Introduction to the Series</a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// inhalt.vue?4c1fabc7